import { RouteConfig } from '@app/types';

/** Keep only the routes whose `condition` is absent or truthy. */
export function filterRouteConfigs<TPath extends string>(
  routes: RouteConfig<TPath>[]
): RouteConfig<TPath>[] {
  return routes.filter(({ condition }) => condition ?? true);
}
